export default {
    approvals: "Goedkeuringen",
    delegates: "Afgevaardigden",
    employees: "Medewerkers"
}